<template>
  <div v-show="headerVisible" class="bluefire-wap-header">
    <div class="btn-back" @click="navgatorBack" v-show="backVisible">
      <img src="../../../assets/wap/icon-wap-back.png" alt="">
    </div>
    <div class="text-area" v-if="titleTypeLock">
      {{ headerText }}
    </div>
    <div class="text-area" v-if="!titleTypeLock">
      <div @click="titleShow">{{ headerText }}<i :class="titleLock?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
      <div class="title-list-area" v-if="titleLock">
        <div :class="'btn-area ' + (item.title === headerText ? 'active' : '')" v-for="item in menuList" :key="item.title">
          <a :href="item.href">
            <span>{{ item.title }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="title-mask-area" @click="titleShow" v-if="titleLock"></div>
    <div class="avatar-area">
      <!--用户头像-->
      <img class="avatar-img" @click="dropdownShow" :src="getImage(userinfo.touxiang)" :title="userinfo.username" />
      <div class="dropdown-list" v-show="dropdownLock">
        <span></span>
        <div class="dropdown-line backindex">
          <el-button type="primary" @click="backIndex">返回首页</el-button>
        </div>
        <div class="dropdown-line accountshow">
          <el-button type="primary" @click="accountShow">切换账号</el-button>
        </div>
        <!-- 调试通知消息时使用
        <div class="dropdown-line accountshow">
          <a type="primary" href="/frontend/dingSign/17310/415750">测试415750</a>
        </div>
        -->
      </div>
    </div>
    <!--账户列表-->
    <div class="account-list-bg" v-show="accountLock">
      <div class="account-list-wrap">
        <div class="title-area">请选择登录账号</div>
        <div class="account-list">
          <!--账户列表循环 start-->
          <div v-for="(user, index) in userList" :class="'account-line' + (user.isLogin ? ' active' : '')" :key="index" @click="changeLogin(user)">
            <img :src="getImage(user.touxiang)" />
            <div class="border-area">
              <span>{{ user.username }}</span>
            </div>
          </div>
          <!--账户列表循环 end-->
        </div>
        <div :class="'btn-addarea' + (userList.length && userList[0] ? '' : ' active')">
          <el-button class="btn-addaccount" @click="accountAdd">+添加新账号</el-button>
        </div>
        <el-button class="btn-close" @click="accountHide">×</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { _post } from '@/utils/http';
import * as dd from 'dingtalk-jsapi';
import lockr from 'lockr';

export default {
  props: {
    headerText: {
      type: String,
      default() {
        return '昆仑数据信息平台';
      }
    },
    headerVisible: {
      type: Boolean,
      default() {
        return true;
      }
    },
    backVisible: {
      type: Boolean,
      default() {
        return true;
      }
    },
    userListLock: {
      type: Boolean,
      default() {
        return true;
      }
    },
    menu: {
      type: Array,
      default() {
        return [];
      }
    },
    controller: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    titleTypeLock: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      dropdownLock: false,
      accountLock: false,
      titleLock: false,
      userList: [],
      userinfo: {
        userid: '',
        touxiang: '',
        truename: '',
      },
      menuList: []
    };
  },
  methods: {
    // 返回上一页
    navgatorBack: function() {
      this.$router.go(-1);
    },
    // 头像下拉
    dropdownShow: function() {
      this.dropdownLock = !this.dropdownLock;
    },
    // 账号列表弹窗
    accountShow: function() {
      this.accountLock = true;
      this.dropdownLock = false;
    },
    // 隐藏弹窗
    accountHide: function() {
      this.accountLock = false;
    },
    //
    titleShow: function() {
      this.titleLock = !this.titleLock;
    },
    // 添加新账号
    accountAdd: function() {
      this.$alert('如需新增账号请于运营部联系');
    },
    // 切换登录
    async changeLogin(user) {
      const data = {
        loginCipher: [lockr.get('jwt-dd'), user.userid].join(' '),
        site: this.$siteName
      };
      // this.$alert(JSON.stringify(data));

      _post({
        url: '/index/login/dingLogin',
        data
      }).then((res) => {
        if (res.result === 1) {
          this.initUserInfo(res.data);
          this.accountHide();
        } else {
          this.errorProcess(res);
        }
      });
    },
    async getDingToken() { // 获取钉钉的usercode
      let that = this;
      return new Promise((resolve, reject) => {
        const dingToken = lockr.get('jwt-dd');

        if (dingToken) {
          resolve(dingToken);
        } else if (dd.env.platform !== 'notInDingTalk') {
          dd.runtime.permission.requestAuthCode({
            corpId: 'ding401dd62104016fd535c2f4657eb6378f',
            onSuccess: function(result) {
              _post({
                url: '/index/login/getDingTokenByCode',
                data: {
                  code: result.code
                }
              }).then((res) => {
                if (res.result === 1) {
                  // 写钉钉用户ID
                  lockr.set('jwt-dd', res.data.uid);
                  resolve(res.data.uid);
                } else {
                  that.errorMsg = res.msg;
                  that.$message.error(res.msg);
                  reject(res.msg);
                }
              });
            }
          });
        } else {
          // 不在钉钉环境返回空的钉钉逻辑
          resolve('');
        }
      });
    },
    async initDingUser() {
      const dingToken = await this.getDingToken();
      const site = this.$siteName;
      let data = { dingToken, site };
      if (this.controller !== '') {
        data.controller = this.controller;
      }
      if (this.action !== '') {
        data.action = this.action;
      }

      // 初始化请求
      _post({
        url: '/index/login/getDingUserInfo',
        data: data
      }).then((res) => {
        if (res.result === 1) {
          this.userList = res.data.userList;

          if (this.userList.length > 0) {
            this.userinfo = Object.assign({}, this.userList.find(user => user.isLogin));
          }

          if (!this.userinfo.userid) {
            lockr.set('jwt', '');
            this.accountShow();
          } else {
            this.$emit('update:userListLock', false);
            if (res.data.menuList) {
              this.menuList = res.data.menuList.child;
              this.$emit('update:menu', this.menuList);
            }
            // 初始化登录用户信息
            this.userinfo = Object.assign({}, this.userinfo, res.data.userInfo);
          }
        } else {
          this.errorProcess(res);
        }
      });
    },
    initUserInfo(login) {
      this.userinfo = Object.assign({}, this.userinfo, login);

      console.info(this.userinfo);
      lockr.set('jwt', login.token);
      window.location.reload();
    },
    getImage(touxiang) {
      return touxiang !== '' ? `${this.$jiemo.imghome}/Upload/teacher/${touxiang}` : this.defaultAvatar;
    },
    setWebMeta: function() {
      let oMeta = document.createElement('meta');
      oMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0, user-scalable=0';
      // oMeta.content = 'width=1080, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0, user-scalable=0';
      oMeta.name = 'viewport';
      document.getElementsByTagName('head')[0].appendChild(oMeta);
    },
    // 返回首页
    backIndex: function() {
      this.$router.push({ name: 'h5Tools' });
    },
    // 错误处理
    errorProcess: function(res) {
      console.error(res);
      // 错误信息
      if (res.code === 4001) {
        lockr.set('jwt', '');
        lockr.set('jwt-dd', '');

        this.$alert('请重新登录');
      } else { // 其他错误
        this.errorMsg = res.msg;
        this.$message.error(res.msg);
      }
    }
  },
  watch: {
    userinfo() {
      this.getImage();
    }
  },
  computed: {
    defaultAvatar() {
      // eslint-disable-next-line
      return require(`@/assets/images/icon-avatar-default.png`);
    },
  },
  mounted() {
    this.setWebMeta();
    this.initDingUser();
  },
};
</script>
<style scoped>
  .bluefire-wap-header{
    position: fixed;
    width: 100%;
    height: 8vh;
    line-height: 8vh;
    background: #fff;
    text-align: center;
    z-index: 20;
    top: 0;
    left: 0;
  }
  .bluefire-wap-header .text-area{
    font-size: 4.5vw;
    color: #333;
    font-weight: bold;
    position: relative;
    z-index: 19;
    background: #fff;
  }
  .bluefire-wap-header .text-area .title-list-area{
    background: #FFFFFF;
    line-height: 12vh;
    box-shadow: inset 0 5px 5px rgba(0,0,0,.1);
  }
  .bluefire-wap-header .text-area .title-list-area .btn-area{
    display: inline-block;
    background: #F6F6F6;
    margin: 0 2vw;
    padding: 0 5vw;
    border-radius:1vw;
    line-height: 10.6vw;
    font-size: 4vw;
    font-weight: normal;
  }
  .bluefire-wap-header .text-area .title-list-area .btn-area a{
    color: #000;
  }
  .bluefire-wap-header .text-area .title-list-area .btn-area.active{
    background: rgba(4, 150, 255, 0.1);
  }
  .bluefire-wap-header .text-area .title-list-area .btn-area.active a{
    color: #23A3FF;
  }
  .bluefire-wap-header .btn-back{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0;
    z-index: 20;
    cursor: pointer;
    padding: 0 4vw;
  }
  .bluefire-wap-header .btn-back img{
    width: 2vw;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
  }
  .bluefire-wap-header .avatar-area{
    position: absolute;
    right: 4vw;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
  }
  .bluefire-wap-header .avatar-area .avatar-img{
    display: block;
    width: 8vw;
    height: 8vw;
    border-radius: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent
  }
  .bluefire-wap-header .avatar-area .dropdown-list{
    position: absolute;
    top: 8vh;
    right: 0;
    background: #fff;
    box-shadow: 0 0 1vw rgba(0,0,0,.1);
    padding: 0.4vw 3vw;
    width: 34vw;
    border-radius: 1.4vw;
    line-height: 9vw;
    padding: 2vw 0;
  }
  .bluefire-wap-header .avatar-area .dropdown-list > span{
    position: absolute;
    top: -1.8vw;
    right: 3vw;
    border-bottom: 1.8vw solid #fff;
    border-left: 1.4vw solid transparent;
    border-right: 1.4vw solid transparent;
  }
  .bluefire-wap-header .avatar-area .dropdown-list .el-button{
    background: none;
    padding: 0;
    font-size: 4vw;
    color: #333;
    border: none;
    height: 6vw;
    line-height: 6vw;
    padding-left: 6vw;
  }
  .bluefire-wap-header .avatar-area .dropdown-list .dropdown-line.backindex .el-button{
    background: url(../../../assets/wap/icon-wap-2.png) no-repeat left center;
    background-size: 4vw auto;
  }
  .bluefire-wap-header .avatar-area .dropdown-list .dropdown-line.accountshow .el-button{
    background: url(../../../assets/wap/icon-wap-1.png) no-repeat left center;
    background-size: 4vw auto;
  }
  .bluefire-wap-header .account-list-bg{
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 21;
    background: rgba(0,0,0,.7);
  }
  .bluefire-wap-header .account-list-wrap{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 21;
    width: 92vw;
    transform: translate(-50%,-50%);
    background: #fff;
    padding: 0 5.2vw 5vw;
    border-radius: 2vw;
  }
  .bluefire-wap-header .account-list{
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .bluefire-wap-header .account-list-wrap .title-area{
    line-height: 17.8vw;
    font-size: 4.8vw;
    font-weight: bold;
    border-bottom: 0.5px solid #ececec;
  }
  .bluefire-wap-header .account-list-wrap .btn-close{
    position: absolute;
    bottom: -14vw;
    left: 50%;
    transform: translateX(-50%);
    width: 8vw;
    height: 8vw;
    line-height: 8vw;
    color: #fff;
    border-radius: 100%;
    border:0.5px solid #fff;
    text-align: center;
    padding: 0;
    background: none;
  }
  .bluefire-wap-header .account-list-wrap .btn-addarea{
    text-align: right;
    padding: 2vw 0;
  }
  .bluefire-wap-header .account-list-wrap .btn-addarea .el-button{
    height: 10.6vw;
    line-height: 10.6vw;
    border: none;
    background: none;
    color: #0496FF;
    font-size: 4vw;
    padding: 0;
  }
  .bluefire-wap-header .account-list-wrap .btn-addarea.active{
    padding: 8vw 0 4vw;
  }
  .bluefire-wap-header .account-list-wrap .btn-addarea.active .el-button{
    display: block;
    width: 55vw;
    margin: auto;
    border: 0.5px solid #0496ff;
    border-radius: 1.5vw;
  }
  .bluefire-wap-header .account-line{
    height: 15.4vw;
    line-height: 15.4vw;
    font-size: 0;
    text-align: left;
  }
  .bluefire-wap-header .account-line.active{
    background: #f8f8f8;
  }
  .bluefire-wap-header .account-line img{
    width: 8vw;
    height: 8vw;
    display: inline-block;
    vertical-align: middle;
  }
  .bluefire-wap-header .account-line .border-area{
    display: inline-block;
    vertical-align: middle;
    width: 70vw;
    margin-left: 3vw;
    border-bottom: 0.5px solid #ececec;
  }
  .bluefire-wap-header .account-line span{
    display: inline-block;
    vertical-align: middle;
    font-size: 4vw;
    white-space: nowrap;
    width: 61vw;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }
  .bluefire-wap-header .account-line .el-button{
    width: 8vw;
    height: 7vw;
    line-height: 7vw;
    font-size: 6vw;
    padding: 0;
    display: inline-block;
    vertical-align: middle;
    border: none;
    color: #cdcdcd;
    background: none;
  }
  .bluefire-wap-header .account-line.active .el-button{
    display: none;
  }
  .bluefire-wap-header .login-area{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: url(../../../assets/login/images/bg-wap.jpg) no-repeat center;
    background-size: 100% 100%;
    z-index: 32;
  }
  .bluefire-wap-header .login-area .logo-area{
    padding: 18vw 0 3vw;
  }
  @keyframes logomove{
    0%{
      transform: translateY(5px);
    }
    50%{
      transform: translateY(-5px);
    }
    100%{
      transform: translateY(5px);
    }
  }
  .bluefire-wap-header .login-area .logo-area img{
    width: 32vw;
    animation: logomove 3s linear infinite;
  }
  .bluefire-wap-header .login-area .form-area{
    width: 76vw;
    margin: auto;
  }
  .bluefire-wap-header .login-area .form-area .waplogin-input{
    text-align: center;
  }
  .bluefire-wap-header .login-area .form-area .waplogin-input input {
    border: none;
    background: none;
    width: 76vw;
    height: 12vw;
    border: none;
    line-height: 12vw;
    border-radius: 6vw;
    font-size: 4vw;
    padding:0 4vw;
    outline: none;
    border: 1px solid #fff;
    background: rgba(255,255,255,.62);
    color: #616161;
    font-family: "微软雅黑", Microsoft Yahei;
    transition: all linear 0.2s;
  }
  .bluefire-wap-header .login-area .form-area .waplogin-input input:-internal-autofill-selected {
    /*内置阴影填充 背景颜色*/
    box-shadow: inset 0 0 0 1000px rgba(255,255,255,.62) !important;
    /*只有谷歌兼容 字体颜色*/
    -webkit-text-fill-color: #616161 !important;
  }
  .bluefire-wap-header .login-area .form-area .waplogin-input input:-webkit-autofill{
    -webkit-box-shadow: 0 0 0 400px rgba(255,255,255,.62) inset;
    -webkit-text-fill-color: #616161;
  }

  .bluefire-wap-header .login-area .form-area .waplogin-input input:-webkit-autofill,
  .bluefire-wap-header .login-area .form-area .waplogin-input input:-webkit-autofill:hover,
  .bluefire-wap-header .login-area .form-area .waplogin-input input:-webkit-autofill:focus,
  .bluefire-wap-header .login-area .form-area .waplogin-input input:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
  }
  .bluefire-wap-header .login-area .form-area .waplogin-input input:focus{
    box-shadow: 0 0 10px rgba(255,255,255,.6);
  }
  .bluefire-wap-header .login-area .form-area .waplogin-btn-area{
    padding-top: 9vw;
  }
  .bluefire-wap-header .login-area .form-area .waplogin-btn-area .waplogin-btn{
    width: 100%;
    display: block;
    text-align: center;
    height: 11.4vw;
    line-height: 11.4vw;
    border-radius: 5.7vw;
    background: #fff;
    color: #292929;
    font-size: 4vw;
    border: none;
    padding: 0;
  }
  .bluefire-wap-header .login-area .form-area .waplogin-btn-area .waplogin-btn.back{
    background: none;
    color: #ccc;
    margin-left: 0;
    font-size: 3.7vw;
  }
  .bluefire-wap-header .login-area .copy-area{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    line-height:4.2vw;
  }
  .bluefire-wap-header .login-area .copy-area h3{
    font-size: 3vw;
    color: #fff;
    font-weight: normal;
    padding-bottom: 3vw;
  }
  .bluefire-wap-header .login-area .copy-area p{
    font-size: 3vw;
    color: rgba(255,255,255,.5);
    padding-bottom: 5vw;
  }
  .title-mask-area{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background:rgba(0,0,0,.7);
    cursor: pointer;
  }
</style>
<style>
  @media (max-width: 1000px) {
    .el-message-box{
      width: 92%;
    }
    .el-message{
      width: 92%;
      min-width: auto;
    }
  }
  .bluefire-wap-wrap{
    background: #f8f8f8;
    min-height: 100vh;
    padding-bottom: 15vw;
    -webkit-tap-highlight-color: transparent;
    color: #333;
    padding-top: 8vh;
  }
  .bluefire-wap-wrap .el-input__inner{
    color: #333;
  }
  .bluefire-common-btnarea{
    padding: 3vw 0 6vw;
    clear: both;
    text-align: center;
  }
  .bluefire-common-btnarea .el-button{
    display: inline-block;
    width: 65.8vw;
    height: 10.6vw;
    line-height: 10.6vw;
    border-radius: 5.3vw;
    background: #0496ff;
    color: #fff;
    font-size: 3.73vw;
    padding: 0;
    border: none;
  }
  .el-button.btn-close-popup{
    background: none;
    position: absolute;
    bottom: -12vw;
    left: 50%;
    transform: translateX(-50%);
    width: 7.7vw;
    height: 7.7vw;
    line-height: 7.7vw;
    padding: 0;
    text-align: center;
    border-radius: 100%;
    border: 0.5px solid #fff;
    color: #fff;
    font-size: 0;
  }
  .btn-close-popup font{
    display: inline-block;
    vertical-align: middle;
    font-size: 6vw;
    position: relative;
    top: -0.4vw;
  }
  .btn-close-popup-fullpage{
    position: absolute;
    top: 2vw;
    left: 2vw;
    z-index: 9;
    border: none;
    font-size: 6vw;
    padding: 2vw;
  }
  .popup-common-title{
    text-align: center;
    padding: 5vw 0;
    font-weight: bold;
    font-size: 4.8vw;
  }
  :focus,:active{
    outline: none !important;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .el-radio-button, .el-radio-button__inner{
    outline: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #333;
  }
  .el-scrollbar > .el-scrollbar__bar{
    opacity: 1 !important;
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    box-shadow: none !important;
  }
</style>
